import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import PipelineBlokk from "./PipelineBlokk";
import SakerBlokk from "./SakerBlokk";
import EntitetBlokk from "./EntitetBlokk";
import BeslutningBlokk from "./BeslutningBlokk";

const specAttrs = {
  spec: {
    default: {},
    parseHTML: (el) => {
      try { return JSON.parse(el.getAttribute("data-spec") || "{}"); } catch { return {}; }
    },
    renderHTML: (attrs) => ({ "data-spec": JSON.stringify(attrs.spec || {}) }),
  },
};

const blokkVernBak = (editor, navn) => {
  const { state } = editor;
  const { $from, empty } = state.selection;
  if (!empty || $from.parentOffset !== 0 || $from.depth === 0) return false;
  const $pos = state.doc.resolve($from.before($from.depth));
  return !!($pos.nodeBefore && $pos.nodeBefore.type.name === navn);
};

const blokkVernFrem = (editor, navn) => {
  const { state } = editor;
  const { $from, empty } = state.selection;
  if (!empty || $from.depth === 0) return false;
  if ($from.parentOffset !== $from.parent.content.size) return false;
  const $pos = state.doc.resolve($from.after($from.depth));
  return !!($pos.nodeAfter && $pos.nodeAfter.type.name === navn);
};

const lagNode = (name, blokk, Comp) => Node.create({
  name,
  group: "block",
  atom: true,
  selectable: false,
  isolating: true,
  draggable: true,
  addKeyboardShortcuts() {
    return {
      Backspace: () => blokkVernBak(this.editor, this.name),
      Delete: () => blokkVernFrem(this.editor, this.name),
    };
  },
  addAttributes: () => ({ ...specAttrs }),
  parseHTML: () => [{ tag: `div[data-blokk="${blokk}"]` }],
  renderHTML: ({ HTMLAttributes }) => ["div", mergeAttributes({ "data-blokk": blokk }, HTMLAttributes)],
  addNodeView: () => ReactNodeViewRenderer(Comp),
});

export const PipelineNode = lagNode("pipelineBlokk", "pipeline", PipelineBlokk);
export const SakerNode = lagNode("sakerBlokk", "saker", SakerBlokk);
export const EntitetNode = lagNode("entitetBlokk", "entitet", EntitetBlokk);

export const BeslutningNode = Node.create({
  name: "beslutningBlokk",
  group: "block",
  atom: true,
  selectable: false,
  isolating: true,
  draggable: true,
  addKeyboardShortcuts() {
    return {
      Backspace: () => blokkVernBak(this.editor, this.name),
      Delete: () => blokkVernFrem(this.editor, this.name),
    };
  },
  addAttributes: () => ({
    status: { default: "open", parseHTML: (el) => el.getAttribute("data-status") || "open", renderHTML: (a) => ({ "data-status": a.status }) },
    tittel: { default: "", parseHTML: (el) => el.getAttribute("data-tittel") || "", renderHTML: (a) => ({ "data-tittel": a.tittel }) },
    alt: { default: "", parseHTML: (el) => el.getAttribute("data-alt") || "", renderHTML: (a) => ({ "data-alt": a.alt }) },
    notat: { default: "", parseHTML: (el) => el.getAttribute("data-notat") || "", renderHTML: (a) => ({ "data-notat": a.notat }) },
    anbefalt: { default: "", parseHTML: (el) => el.getAttribute("data-anbefalt") || "", renderHTML: (a) => ({ "data-anbefalt": a.anbefalt }) },
    eier: { default: "", parseHTML: (el) => el.getAttribute("data-eier") || "", renderHTML: (a) => ({ "data-eier": a.eier }) },
    frist: { default: "", parseHTML: (el) => el.getAttribute("data-frist") || "", renderHTML: (a) => ({ "data-frist": a.frist }) },
  }),
  parseHTML: () => [{ tag: 'div[data-blokk="beslutning"]' }],
  renderHTML: ({ HTMLAttributes }) => ["div", mergeAttributes({ "data-blokk": "beslutning" }, HTMLAttributes)],
  addNodeView: () => ReactNodeViewRenderer(BeslutningBlokk),
});
